module.exports = __webpack_public_path__ + "media/react/assets/images/small-logo-eab65f121a1f8f888a01c64f6d1a77b4.png";